import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import router from '@/router';
import { moduleFantasy } from './moduleFantasy.js';
import { moduleCasino } from './moduleCasino.js';
import { moduleCampaigns } from './moduleCampaigns.js';
import { moduleReporting } from './moduleReporting.js';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    warningTime: 0,
    login: {
      step: 1,
      loading: false,
      token: '',
      role: ''
    },
    statusCode: {
      userLogin: {state:'', msg:'', loading: false},
      userValidate: {state:'', msg:'', loading: false},
      refreshToken: {state:'', msg:'', loading: false},
      createContest: {state:'', msg:'', loading: false},
      editContest: {state:'', msg:'', loading: false},
      createMatchset: {state:'', msg:'', loading: false},
      toggleMatchset: {state:'', msg:'', loading: false},
      detailMatchset: {state:'', msg:'', loading: false},
      editMatchset: {state:'', msg:'', loading: false},
      getMatches: {state:'', msg:'', loading: false},
      createCompetition: {state:'', msg:'', loading: false},
      toggleCompetition: {state:'', msg:'', loading: false},
      editCompetition: {state:'', msg:'', loading: false},
      createOperator: {state:'', msg:'', loading: false},
      editOperator: {state:'', msg:'', loading: false},
      toggleOperator: {state:'', msg:'', loading: false},
      createProvider: {state:'', msg:'', loading: false},
      toggleOperatorProvider: {state:'', msg:'', loading: false},
      toggleProvider: {state:'', msg:'', loading: false},
      editProvider: {state:'', msg:'', loading: false},
      createNetwork: {state:'', msg:'', loading: false},
      editNetwork: {state:'', msg:'', loading: false},
      toggleNetwork: {state:'', msg:'', loading: false},
      createGame: {state:'', msg:'', loading: false},
      multiCreateGame: {state:'', msg:'', loading: false},
      editGame: {state:'', msg:'', loading: false},
      toggleGame: {state:'', msg:'', loading: false},
      createOperatorProvider: {state:'', msg:'', loading: false},
      editOperatorProvider: {state:'', msg:'', loading: false},
      addIpOperator: {state:'', msg:'', loading: false},
      addIpProvider: {state:'', msg:'', loading: false},
      roundsTable: {state:'', msg:'', loading: false},
      toggleRound: {state:'', msg:'', loading: false},
      getTransactions: {state:'', msg:'', loading: false},
      detailRound: {state:'', msg:'', loading: false},
      createUser: {state:'', msg:'', loading: false},
      editUser: {state:'', msg:'', loading: false},
      changePassword: {state:'', msg:'', loading: false},
      createFreespins: {state:'', msg:'', loading: false},
      toggleFreespins: {state:'', msg:'', loading: false},
      deleteIp:{state:'', msg:'', loading: false},
      createPayout: {state:'', msg:'', loading: false},
      editPayout: {state:'', msg:'', loading: false},
      getCategories: {state:'', msg:'', loading: false},
      createCategories: {state:'', msg:'', loading: false},
      editCategories: {state:'', msg:'', loading: false},
      getLobbies: {state:'', msg:'', loading: false},
      createLobbies: {state:'', msg:'', loading: false},
      editLobbies: {state:'', msg:'', loading: false},
      createFreerounds: {state:'', msg:'', loading: false},
      toggleFreerounds: {state:'', msg:'', loading: false},
      createOptin: {state:'', msg:'', loading: false},
      toggleOptin: {state:'', msg:'', loading: false},
    },
    userData: {},
    providers: [],
    operators: [],
    games: [],
    users: {},
    administrators: [],
    accountManagers: [],
    notification: {
      status: false,
      message: ''
    },
    payout: [],
    freerounds: [],
    optin: [],
    referafriend: [],
  },
  getters: {
    getNotification: state => {
      return state.notification;
    },
    getWarningTime: state => {
      return state.warningTime;
    },
  },
  mutations: {
    setUserState(state, user){
      state.userData = user;
      state.login.role = user.rol;
    },
    setUserToken(state, token){
      state.login.token = token;
      // sessionStorage.setItem('token', token);
    },
    setUserRole(state, role){   // TODO, DEVELOP
      state.login.role = role;
    },
    setLoginStep(state, step){
      state.login.step = step;
    },
    setLogout(state){
      state.login.step = 1;
      state.login.token = '';
      // sessionStorage.setItem('token', token);
    },
    setNotification(state, message){
      state.notification.status = true;
      state.notification.message = message;
    },
    setStatusCode(state, payload){
      state.statusCode[payload.key].state = payload.state;
      state.statusCode[payload.key].msg = payload.msg;
      state.statusCode[payload.key].loading = payload.loading;
    },
    setWarningTime(state){
      state.warningTime++;
    },
    resetWarningTime(state){
      state.warningTime = 0;
    },
    getProviders(state,list){
      state.providers = list;
    },
    getOperators(state,list){
      state.operators = list;
    },
    getAdministrators(state, list){
       state.administrators = list;
    },
    getAccountManagers(state,list){
      state.accountManagers = list;
    },
    getGames(state,list){
      state.games = list;
    },
    getUsers(state,list){
      state.users = list;
    },
    getPayout(state,list){
      state.payout = list;
    }
  },
  actions: {
    async userLogin({commit}, userdata) {
      commit('setStatusCode',  {key: 'userLogin', state:'', msg:'', loading: true});
      commit('setWarningTime');
      const config = userdata;
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/user/login`, config)
          .then((res) => {
            commit('setUserState', res.data);
            commit('setStatusCode',  {key: 'userLogin', state: res.status, msg:res.statusText, loading: false});
            commit('setLoginStep', 2);
          })
          .catch((error) => {
            commit('setStatusCode',  {key: 'userLogin', state: error.response.status, msg: error.response.statusText, loading: false});
            commit('setNotification', 'Credentials invalid');
            console.log(error);
          });
    },

    async userValidate({commit, state}, pindata) {
      commit('setStatusCode',  {key: 'userValidate', state:'', msg:'', loading: true});
      const config = {
        id: state.userData.id,
        pin: pindata
      };
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/user/validatelogin`, config)
          .then((res) => {
            commit('setUserToken', res.data);
            commit('setStatusCode',  {key: 'userValidate', state: res.status, msg:res.statusText, loading: false});
            router.push('/home');
          })
          .catch((error) => {
            commit('setStatusCode',  {key: 'userValidate', state: error.response.status, msg: error.response.statusText, loading: false});
            commit('setNotification', 'Credentials invalid');
            console.log(error);
          });
    },

    async refreshToken({commit, state}) {
      commit('setStatusCode',  {key: 'refreshToken', state:'', msg:'', loading: true});
      const config = {
        headers: {Authorization: `bearer ${state.login.token}`},
      };
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/user/refresh`, {}, config)
          .then((res) => {
            commit('setUserToken', res.data);
            commit('setStatusCode',  {key: 'refreshToken', state: res.status, msg:res.statusText, loading: false});
          })
          .catch((error) => {
            commit('setStatusCode',  {key: 'refreshToken', state: error.response.status, msg: error.response.statusText, loading: false});
            commit('setNotification', 'Token can not be updated');
            console.log(error);
          });
    },

    userLogout({commit}) {
      commit('setLogout');
      commit('setUserState', {});
      if(router.history.current.path != '/' && router.history.current.path != '/login') {   // fix duplicated path error, when logout by timeout  
        router.push({ name: 'Login' });
      }
    },

    async getProviders({commit, state}) {
      const config = {
          headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setWarningTime');
      axios.get(`${process.env.VUE_APP_SERVER}/backoffice/provider/list`, config)
        .then((res) => {
            commit('getProviders', res.data);
        })
        .catch((error) => {
            console.log(error);
        });
    },

    async createProvider({commit, state}, providerData) {
      const config = {
          headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setStatusCode',  {key: 'createProvider', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/provider/create`,providerData.data, config)
          .then((res) => {
              commit('setStatusCode',  {key: 'createProvider', state: res.status, msg:res.statusText, loading: false});
              commit('setNotification', 'Succesfully created provider');
          })
          .catch((error) => {
              commit('setStatusCode',  {key: 'createProvider', state: error.response.status, msg: error.response.statusText, loading: false});
              commit('setNotification', `Provider can't be created by ${error.response.statusText}`);
              console.log(error);
          });
    },

    async toggleProvider({commit, state}, providerId) {
      const config = {
        headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setStatusCode',  {key: 'toggleProvider', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/provider/${providerId}/toggle`, {}, config)
          .then((res) => {
            commit('setStatusCode',  {key: 'toggleProvider', state: res.status, msg:res.statusText, loading: false});
          })
          .catch((error) => {
            commit('setStatusCode',  {key: 'toggleProvider', state: error.response.status, msg: error.response.statusText, loading: false});
          });
    },

    async editProvider({commit, state}, providerData) {
      const config = {
          headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setStatusCode',  {key: 'editProvider', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/provider/${providerData._id}/edit`,providerData.data, config)
          .then((res) => {
            commit('setStatusCode',  {key: 'editProvider', state: res.status, msg:res.statusText, loading: false});
            commit('setNotification', 'Succesfully edited provider');
          })
          .catch((error) => {
            commit('setStatusCode',  {key: 'editProvider', state: error.response.status, msg: error.response.statusText, loading: false});
            commit('setNotification', `Provider can't be edited by ${error.response.statusText}`);
            console.log(error);
          });
    },

    async getOperators({commit, state}) {
      const config = {
          headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setWarningTime');
      axios
          .get(`${process.env.VUE_APP_SERVER}/backoffice/bookmaker/list`, config)
          .then((res) => {
              commit('getOperators', res.data);
          })
          .catch((error) => {
              console.log(error);
          });
    },

    async createOperator({commit, state}, operatorData) {
      const config = {
          headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setStatusCode',  {key: 'createOperator', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/bookmaker/create`,operatorData.data, config)
          .then((res) => {
            commit('setStatusCode',  {key: 'createOperator', state: res.status, msg:res.statusText, loading: false});
            commit('setNotification', 'Succesfully created operator');
          })
          .catch((error) => {
            console.log(error);
            commit('setStatusCode',  {key: 'createOperator', state: error.response.status, msg: error.response.statusText, loading: false});
            commit('setNotification', `Operator can't be created by ${error.response.statusText}`);
            console.log(error);
          });
    },

    async editOperator({commit, state}, operatorData) {
      const config = {
          headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setStatusCode',  {key: 'editOperator', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/bookmaker/${operatorData._id}/edit`,operatorData.data, config)
          .then((res) => {
            commit('setStatusCode',  {key: 'editOperator', state: res.status, msg:res.statusText, loading: false});
            commit('setNotification', 'Succesfully edited operator');
          })
          .catch((error) => {
            commit('setStatusCode',  {key: 'editOperator', state: error.response.status, msg: error.response.statusText, loading: false});
            commit('setNotification', `Operator can't be edited by ${error.response.statusText}`);
            console.log(error);
          });
    },

    async toggleOperator({commit, state}, operatorId) {
      const config = {
        headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setStatusCode',  {key: 'toggleOperator', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/bookmaker/${operatorId}/toggle`, {}, config)
          .then((res) => {
            commit('setStatusCode',  {key: 'toggleOperator', state: res.status, msg:res.statusText, loading: false});
          })
          .catch((error) => {
            commit('setStatusCode',  {key: 'toggleOperator', state: error.response.status, msg: error.response.statusText, loading: false});
          });
    },

    async toggleOperatorProvider({commit, state}, data) {
      const config = {
        headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setStatusCode',  {key: 'toggleOperatorProvider', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/bookmaker/${data.operatorId}/provider/${data.providerId}/toggle`, {}, config)
          .then((res) => {
            commit('setStatusCode',  {key: 'toggleOperatorProvider', state: res.status, msg:res.statusText, loading: false});
          })
          .catch((error) => {
            commit('setStatusCode',  {key: 'toggleOperatorProvider', state: error.response.status, msg: error.response.statusText, loading: false});
          });
    },

    async addOperatorProvider({commit,state}, operatorProviderData){
      const config = {
          headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setStatusCode',  {key: 'createOperatorProvider', state: '', msg: '', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/bookmaker/${operatorProviderData.data.operator}/provider`,operatorProviderData.data, config)
          .then((res) => {
              commit('setStatusCode',  {key: 'createOperatorProvider', state: res.status, msg:res.statusText, loading: false});
              commit('setNotification', 'Succesfully added provider to the operator');
          })
          .catch((error) => {
              commit('setStatusCode',  {key: 'createOperatorProvider', state: error.response.status, msg: error.response.statusText, loading: false});
              console.log(error);
          });
    },

    async editOperatorProvider({commit,state}, operatorProviderData){
      const config = {
          headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/bookmaker/${operatorProviderData.operator}/provider/${operatorProviderData.provider}`,operatorProviderData.data, config)
          .then((res) => {
              commit('setStatusCode',  {key: 'editOperatorProvider', state: res.status, msg:res.statusText, loading: false});
              commit('setNotification', 'Succesfully edited provider to the operator');
          })
          .catch((error) => {
              commit('setStatusCode',  {key: 'editOperatorProvider', state: error.response.status, msg: error.response.statusText, loading: false});
              console.log(error);
          });
    },
    async deleteOperatorProvider({commit,state}, operatorProviderData){
      const config = {
          headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setWarningTime');
      axios
          .delete(`${process.env.VUE_APP_SERVER}/backoffice/bookmaker/${operatorProviderData.operator}/provider?provider=${operatorProviderData.provider}` ,config)
          .then(() => {
              commit('setNotification', 'Succesfully deleted provider to the operator');
          })
          .catch((error) => {
              console.log(error);
          });
    },
    async deleteOperatorIp({dispatch, commit,state}, operatorData){
      const config = {
          headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setWarningTime');
      return axios
          .delete(`${process.env.VUE_APP_SERVER}/backoffice/bookmaker/${operatorData.operator}/ip?ip=${operatorData.ip}` ,config)
          .then(() => {
              commit('setStatusCode',  {key: 'deleteIp', state: 200, msg:'Succesfully', loading: false});
              commit('setNotification', 'Succesfully deleted operator ip');
              dispatch('getOperators');
          })
          .catch((error) => {
              console.log(error);
          });
    },
    async addOperatorIp({dispatch, commit,state}, operatorProviderData){
      const config = {
          headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setWarningTime');
      return axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/bookmaker/${operatorProviderData.operator}/ip`,{ip:operatorProviderData.ip}, config)
          .then((res) => {
              commit('setStatusCode',  {key: 'addIpOperator', state: res.status, msg:res.statusText, loading: false});
              commit('setNotification', 'Succesfully added ip to the operator');
              dispatch('getOperators');
              return res.status;
          })
          .catch((error) => {
              commit('setStatusCode',  {key: 'addIpOperator', state: error.response.status, msg: error.response.statusText, loading: false});
              console.log(error);
          });
    },
    async addProviderIp({dispatch, commit,state}, providerIpData){
      const config = {
          headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setWarningTime');
      return axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/provider/${providerIpData.provider}/ip`,{ip:providerIpData.ip}, config)
          .then((res) => {
              commit('setStatusCode',  {key: 'addIpProvider', state: res.status, msg:res.statusText, loading: false});
              commit('setNotification', 'Succesfully added ip to the provider');
              dispatch('getProviders');
              return res.status;
          })
          .catch((error) => {
              commit('setStatusCode',  {key: 'addIpProvider', state: error.response.status, msg: error.response.statusText, loading: false});
              console.log(error);
          });
    },
    async deleteProviderIp({dispatch, commit,state}, providerData){
      const config = {
          headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setWarningTime');
      return axios
          .delete(`${process.env.VUE_APP_SERVER}/backoffice/provider/${providerData.provider}/ip?ip=${providerData.ip}` ,config)
          .then(() => {
              commit('setStatusCode',  {key: 'deleteIp', state: 200, msg:'Status', loading: false});
              commit('setNotification', 'Succesfully deleted provider ip');
              dispatch('getProviders');
          })
          .catch((error) => {
              console.log(error);
          });
    },
    async getAccountManagers({commit, state}) {
      const config = {
          headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setWarningTime');
      axios
          .get(`${process.env.VUE_APP_SERVER}/backoffice/user/list?am=true`, config)
          .then((res) => {
              commit('getAccountManagers', res.data);
          })
          .catch((error) => {
              console.log(error);
          });
    },

    async getAdministrators({commit, state}) {
      const config = {
          headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setWarningTime');
      axios
          .get(`${process.env.VUE_APP_SERVER}/backoffice/user/list`, config)
          .then((res) => {
              commit('getAdministrators', res.data);
          })
          .catch((error) => {
              console.log(error);
          });
    },

    async getGames({commit, state}) {
      const config = {
          headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setWarningTime');
      axios
          .get(`${process.env.VUE_APP_SERVER}/backoffice/game/list`, config)
          .then((res) => {
              commit('getGames', res.data);
          })
          .catch((error) => {
              console.log(error);
          });
    },

    async createGame({commit, state}, gameData) {
      const config = {
        headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setStatusCode',  {key: 'createGame', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/game/create`,gameData.data, config)
          .then((res) => {
              commit('setStatusCode',  {key: 'createGame', state: res.status, msg:res.statusText, loading: false});
              commit('setNotification', 'Succesfully created game');
          })
          .catch((error) => {
              commit('setStatusCode',  {key: 'createGame', state: error.response.status, msg: error.response.statusText, loading: false});
              commit('setNotification', `Game can't be created by ${error.response.statusText}`);
              console.log(error);
          });
    },
    async editGame({commit, state}, gameData) {
      const config = {
          headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setStatusCode',  {key: 'editGame', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/game/${gameData._id}/edit`,gameData.data, config)
          .then((res) => {
            commit('setStatusCode',  {key: 'editGame', state: res.status, msg:res.statusText, loading: false});
            commit('setNotification', 'Succesfully edited game');
          })
          .catch((error) => {
            commit('setStatusCode',  {key: 'editGame', state: error.response.status, msg: error.response.statusText, loading: false});
            commit('setNotification', `Game can't be edited by ${error.response.statusText}`);
            console.log(error);
          });
    },

    async toggleGame({commit, state}, gameId) {
      const config = {
        headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setStatusCode',  {key: 'toggleGame', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/game/${gameId}/toggle`, {}, config)
          .then((res) => {
            commit('setStatusCode',  {key: 'toggleGame', state: res.status, msg:res.statusText, loading: false});
          })
          .catch((error) => {
            commit('setStatusCode',  {key: 'toggleGame', state: error.response.status, msg: error.response.statusText, loading: false});
          });
    },

    async multiCreateGame({commit, state}, gameData) {
      const config = {
          headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setStatusCode',  {key: 'multiCreateGame', state:'', msg:'', loading: true});
      commit('setWarningTime');
          axios
              .post(`${process.env.VUE_APP_SERVER}/backoffice/game/multicreate`,gameData, config)
              .then((res) => {
                  commit('setStatusCode',  {key: 'multiCreateGame', state: res.status, msg:res.statusText, loading: false});
                  commit('setNotification', 'Succesfully created games');
              })
              .catch((error) => {
                  commit('setStatusCode',  {key: 'multiCreateGame', state: error.response.status, msg: error.response.statusText, loading: false});
                  commit('setNotification', `Games can't be created by ${error.response.statusText}`);
                  console.log(error);
              });
    },

    async getUsers({commit, state}, data) {
      const config = {
          headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setStatusCode',  {key: 'roundsTable', state: '', msg:'', loading: true});
      commit('setWarningTime');

      let offset = data.offset;
      let limit = data.limit;
      let id = data.id;
      let bookmaker = data.operator;
      let start = data.start;
      let end = data.end;

      let params = `offset=${offset}&limit=${limit}&id=${id}&bookmaker=${bookmaker}&start=${start}&end=${end}`;

      axios
          .get(`${process.env.VUE_APP_SERVER}/backoffice/user/search?${params}`, config)
          .then((res) => {
              commit('getUsers', res.data);
              commit('setStatusCode',  {key: 'roundsTable', state: res.status, msg:res.statusText, loading: false});
          })
          .catch((error) => {
              console.log(error);
              commit('setStatusCode',  {key: 'roundsTable', state: error.response.status, msg: error.response.statusText, loading: false});
          });
    },
    //PAYOUT
    async getPayout({commit, state}) {
      const config = {
          headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setWarningTime');
      axios
          .get(`${process.env.VUE_APP_SERVER}/backoffice/invoice/list`, config)
          .then((res) => {
              commit('getPayout', res.data);
          })
          .catch((error) => {
              commit('setNotification', error);
          });
    },

    async createPayout({commit, state}, payoutData) {
      const config = {
          headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setStatusCode',  {key: 'createPayout', state:'', msg:'', loading: true});
      commit('setWarningTime');

      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/invoice/create`,payoutData, config)
          .then((res) => {
              commit('setStatusCode',  {key: 'createPayout', state: res.status, msg:res.statusText, loading: false});
              commit('setNotification', 'Succesfully created payout');
          })
          .catch((error) => {
              commit('setStatusCode',  {key: 'createPayout', state: error.response.status, msg: error.response.statusText, loading: false});
              commit('setNotification', `Payout can't be created by ${error.response.statusText}`);
              console.log(error);
          });
    },

    async editPayout({commit, state}, payoutData) {
      const config = {
          headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setStatusCode',  {key: 'editPayout', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/invoice/${payoutData.id}/edit`,payoutData.data, config)
          .then((res) => {
              commit('setStatusCode',  {key: 'editPayout', state: res.status, msg:res.statusText, loading: false});
              commit('setNotification', 'Succesfully edited payout');
          })
          .catch((error) => {
              commit('setStatusCode',  {key: 'editPayout', state: error.response.status, msg: error.response.statusText, loading: false});
              commit('setNotification', `Payout can't be edited by ${error.response.statusText}`);
              console.log(error);
          });
    },

    async actionBulkLoad({commit, state},data){
      const action = data.action;
      const config = {
        headers: { Authorization: `bearer ${state.login.token}` },
      };
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/fantasy/${action}/bulkload`, { competition: data.competition }, config)
          .then(() => {
            commit('setNotification', `Succesfully loaded ${action} `);
          })
          .catch((error) => {
            console.log(error);
          });
    },

    async createUser({commit, state}, userData) {
      const config = {
        headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setStatusCode',  {key: 'createUser', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/user/create`,userData.data, config)
          .then((res) => {
              commit('setStatusCode',  {key: 'createUser', state: res.status, msg:res.statusText, loading: false});
              commit('setNotification', 'Succesfully created user');
          })
          .catch((error) => {
              commit('setStatusCode',  {key: 'createUser', state: error.response.status, msg: error.response.statusText, loading: false});
              commit('setNotification', `User can't be created by ${error.response.statusText}`);
              console.log(error);
          });
    },

    async editUser({commit, state}, userData) {
      const config = {
          headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setStatusCode',  {key: 'editUser', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/user/${userData._id}/edit`,userData.data, config)
          .then((res) => {
            commit('setStatusCode',  {key: 'editUser', state: res.status, msg:res.statusText, loading: false});
            commit('setNotification', 'Succesfully edited User');
          })
          .catch((error) => {
            commit('setStatusCode',  {key: 'editUser', state: error.response.status, msg: error.response.statusText, loading: false});
            commit('setNotification', `User can't be edited by ${error.response.statusText}`);
            console.log(error);
          });
    },

    async changePassword({commit, state}, userData) {
      const config = {
          headers: {Authorization: `bearer ${state.login.token}`},
      };
      commit('setStatusCode',  {key: 'changePassword', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/user/changepassword`,userData.data, config)
          .then((res) => {
            commit('setStatusCode',  {key: 'changePassword', state: res.status, msg:res.statusText, loading: false});
            commit('setNotification', 'Succesfully password changed');
          })
          .catch((error) => {
            commit('setStatusCode',  {key: 'changePassword', state: error.response.status, msg: error.response.statusText, loading: false});
            commit('setNotification', `Password can't be changed by ${error.response.statusText}`);
            console.log(error);
          });
    },
  },
  modules: {
    fantasy: moduleFantasy,
    casino: moduleCasino,
    campaigns: moduleCampaigns,
    reporting: moduleReporting,
  }
})
